import React from 'react'
import { Row, Tabs } from 'antd'
import { useAppDispatch } from 'src/app/hooks'
import { PosibleLocale } from 'src/core/models'
import { i18n, useTranslation } from 'next-i18next'
import styles from './ProjectFormHeadline.module.scss'
import { setProjectFormItemValue } from 'src/features'
import { getDescriptionLanguages } from 'src/core/helpers'
import { FormLabels, CustomCol, CustomTextInput } from 'src/components'

const ProjectFormHeadline: React.FC = () => {
  const { t } = useTranslation()
  const dispatch = useAppDispatch()
  const languages = getDescriptionLanguages(t)

  const handleChange = (e:  React.ChangeEvent<HTMLInputElement>, locale: PosibleLocale) => {
    dispatch(setProjectFormItemValue({ key: `headline_${locale}`, value: e.target.value }))
  }

  return <div className={styles.content}>
    <Row>
      <CustomCol>
        <FormLabels
          title={t('Projects.HeadLine')}
          subtitle={t('Projects.HeadLineLabel')}
        />
      </CustomCol>

      <CustomCol>
        <Tabs defaultActiveKey={i18n.language} size={'small'}>
          {languages.map((item) => <Tabs.TabPane tab={item.label} key={item.locale}>
            <CustomTextInput
              name={`headline_${item.locale}`}
              placeholder={t('Projects.Form.TextLabel')}
              onChange={(value) => handleChange(value, item.locale)}
            />
          </Tabs.TabPane>)}
        </Tabs>
      </CustomCol>
    </Row>
  </div>
}

export default ProjectFormHeadline
